module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.className]
  }, [_c('div', {
    staticClass: "BaseCheckbox",
    class: {
      'BaseCheckbox_error': (_vm.errors && _vm.errors.length > 0)
    }
  }, [_c('input', {
    attrs: {
      "id": _vm.fieldName,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.change($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.fieldName
    }
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))]), _vm._v(" "), (_vm.link) ? _c('a', {
    staticClass: "BaseCheckbox__link",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.translate(_vm.linkLabel)))]) : _vm._e()]), _vm._v(" "), _c('BaseErrors', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b59fa57"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseCheckbox.vue
// module id = 508
// module chunks = 1